import { Dispatch, FC, SetStateAction, useMemo } from "react";
import {
    SearchBar,
    SearchBarDataHandler,
} from "../../../assets/components/SearchBar/SearchBar";
import { OptionList } from "../../../assets/helpers/helpers";
import { Products, UsersT } from "../../../models/models";

interface Props {
    users: UsersT;
    products: Products;
    dataHandler: Dispatch<SetStateAction<SearchBarDataHandler>>;
}
const LicenseKeysSearchBar: FC<Props> = ({ users, products, dataHandler }) => {
    const usersOptionList: OptionList = useMemo(() => {
        return users.map(({ username, id }) => {
            const removedEmailAttr =
                username.indexOf("@") !== -1
                    ? username.substring(0, username.indexOf("@"))
                    : username;

            return {
                id: id,
                name: removedEmailAttr,
            };
        }) as OptionList;
    }, [users]);

    const productsOptionList: OptionList = useMemo(() => {
        return products.map(({ name, id }) => {
            return {
                id,
                name,
            };
        }) as OptionList;
    }, [products]);

    return (
        <SearchBar
            usersOptions={usersOptionList}
            productOptions={productsOptionList}
            dataHandler={dataHandler}
            multiSelect={{ users: true, products: true }}
            searchInput={{
                placeholder: "License key",
            }}
            searchByOrderId={{
                placeholder: "Order ID",
            }}
            migratedStatusCheckbox={{
                name: "LicenseKeysActualCheckbox",
                leftLabel: "Migrated only",
                checked: false,
            }}
            showComponents={{
                selectStatus: true,
                dataPikerDateCreated: true,
                dataPikerNextRebillDate: true,
            }}
        />
    );
};

export default LicenseKeysSearchBar;
